import React, { Component } from 'react';
import Toggle from './Toggle';
import flex from '../css/module/flex.css';

class LabelledToggle extends Component {
  render() {
    const { disabled, value, onChange, children } = this.props;

    const style = disabled
      ? { cursor: 'not-allowed', color: '#aaa' }
      : { cursor: 'pointer' };

    return (
      <label
        className={`${flex.justifyContentBetween} full-width ${flex.alignItemsCenter}`}
        style={style}
      >
        <span style={{ fontWeight: 'normal' }}>{children}</span>
        <Toggle
          disabled={disabled}
          value={(!disabled && value) || false}
          onChange={onChange}
        />
      </label>
    );
  }
}

export default LabelledToggle;
